import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../../components/DashboardLayout";
import { formatTime, getDayFromDate } from "../../../utility/Common";
import Loader from "../../../components/Loader";
import { getClassesAPI } from "../../../services/portal/admin/classService";
import { showErrorToastMsg } from "../../../utility/ToastMessage";
import { getMyPaidClassesAPI } from "../../../services/portal/student/studentService";
import { RoutePaths } from "../../../utility/RoutePaths";

const EnrolledClassesPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    loadClasses();
  }, []);

  const loadClasses = async () => {
    setLoading(true);
    try {
      const res = await getMyPaidClassesAPI();
      if (res && res.IsSuccessful && res.Data) {
        setClasses(res.Data);
      }
    } catch (error) {
      console.error("Error loading classes:", error);
      showErrorToastMsg("Failed to load classes");
    } finally {
      setLoading(false);
    }
  };

  const handleCardClick = (classId, e) => {
    // Don't navigate if clicking on the button
    if (e.target.tagName === "BUTTON" || e.target.closest("button")) {
      return;
    }
    navigate(`${RoutePaths.STUDENT_CLASS_DETAILS_PAGE}?classId=${classId}`);
  };

  const renderClassCard = (classItem) => {
    const classId = classItem.ClassId;

    return (
      <div
        key={classId}
        onClick={(e) => handleCardClick(classId, e)}
        className={`bg-white rounded-lg shadow-md p-6 transition duration-300 border-l-4 cursor-pointer ${
          classItem.Status === 1
            ? "border-yellow-600 opacity-75"
            : "border-red-600 hover:shadow-xl"
        }`}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-gray-900">{classItem.Name}</h3>
        </div>

        <div className="flex justify-between text-gray-600 mt-4">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-primary-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <div>
              <p className="font-semibold text-sm">
                {getDayFromDate(classItem.StartDate)}
              </p>
            </div>
          </div>
          <div className="flex items-center">
            <svg
              className="w-5 h-5 mr-2 text-primary-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <div>
              <p className="font-semibold text-sm">
                {formatTime(classItem.StartTime) +
                  " - " +
                  formatTime(classItem.EndTime)}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout title="Dashboard" subtitle="Welcome back!">
      {loading ? (
        <div className="flex justify-center items-center py-12">
          <Loader />
        </div>
      ) : (
        <>
          {/* Available Classes Section */}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Enrolled Classes
            </h2>
            {classes.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-600 text-lg">No classes available</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
                {classes.map((classItem) => renderClassCard(classItem))}
              </div>
            )}
          </div>
        </>
      )}
    </DashboardLayout>
  );
};

export default EnrolledClassesPage;
